<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>
<h1>{{'fs.res.publication.configuration.publicationTypeRelation.title' | hisUi}}</h1>
<p></p>

<div class="layoutBlock">
    <div class="infoMessage columnFullWidth">{{'fs.res.publication.configuration.publicationTypeRelation.subtitle' | hisUi}}</div>
    <br>
    <his-dialog-header
        [showSaveButton] = "true"
        [showResetButton] = "true"
        [showBackButton] = "false"
        (save)="savePublicationTypeRelation()"
        (resetInputs)="reset()">
    </his-dialog-header>
<div class="columnFullWidth">
		<p-panel header="{{'fs.res.publication.configuration.publicationTypeRelation.header' | hisUi}}">
            <div class="infoMessage">{{'fs.res.publication.configuration.publicationTypeRelation.infoMessage' | hisUi}}</div>

            <button (click)="addNewRelationship()" hisImage="plus_circ_green" class="transparent">
                <span>{{'fs.res.publication.configuration.publicationTypeRelation.addNewRelationship' | hisUi}}</span>
            </button>

            <ul class="listSimple">
                <li *ngFor="let relationship of publicationTypeRelationships; let i = index;">
                    <br>
                    <div class="columnFullWidth">
                        <div class="columnThreeQuarter">
                            <his-plam class="columnHalf">
                                <p-autoComplete #content hisDdKey="fs.res.publication.configuration.publicationTypeRelation.parentPublication"
                                    [ngModel]="relationship.parent" (onSelect)="onParentPublicationTypeChange($event, i)" hisEagerDataSource="publicationTypeValue"
                                    (onClear)="onParentPublicationTypeChange(undefined, i)">
                                </p-autoComplete>
                            </his-plam>
                            <his-multiselect-plam #content class="columnHalf"
                                ddKey="fs.res.publication.configuration.publicationTypeRelation.childPublication"
                                dataSource="publicationTypeValue"
                                [selectedOptions]="relationship.childs"
                                (selectedOptionsChange)="onChildPublicationTypeChange($event, i)"
                                field="text">
                            </his-multiselect-plam>
                        </div>
                        <button *ngIf="!doRefresh" (click)="deleteRelationship(i)" hisImage="DELETE" class="icon" [title]="getDeleteButtonToolTip(relationship.parent)"></button>
                    </div>
                    <br>
                    <br>
                    <hr *ngIf="publicationTypeRelationships.length > i+1">
                </li>
            </ul>
            <div class="clearer"></div>
		</p-panel>
	</div>
</div>
